// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FWpw6","list":"styles_list__4NI86"};